import React from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Nav from 'react-bootstrap/Nav'
import Button from 'react-bootstrap/Button'
import InputGroup from 'react-bootstrap/InputGroup'

export function TabsBimestre({ values }) {
  return (
    <Row className="d-flex justify-content-center">
      <Nav variant="pills">
        {values.map((state, index) => (
          <Nav.Item key={index}>
            <Nav.Link eventKey={state.bimestre}>
              {`Bimestre ${state.bimestre}`}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
    </Row>
  )
}

function ErrorDeducciones({ tipo }) {
  switch (tipo) {
    case 'unique':
      return 'Sólo puede elegir una opción que no haya elegido anteriormente.'
    case 'nonDefault':
      return 'Es necesario seleccionar una opción.'
    default:
      return ''
  }
}

export function DeduccionesFA({
  name = '',
  bimestre = '',
  arrayName = '',
  legajo = '',
  legajoIndex = 0,
  text = '',
  property = '',
  options = []
}) {
  const { control, getValues, watch, register, errors } = useFormContext()
  const { fields, append, remove } = useFieldArray({ control, name })

  return (
    <>
      {fields.map((field, index) => {
        return (
          <Form.Row
            className="my-4 d-flex align-items-top justify-content-center"
            key={field.id}
          >
            <Form.Group className="col-6">
              <Form.Label>{`${text} ${index + 1}`}</Form.Label>
              <Form.Control
                as="select"
                name={`${name}.${index}.${property}`}
                defaultValue={field[property]}
                ref={register({
                  required: true,
                  validate: {
                    nonDefault: (v) => Number(v) !== -1,
                    unique: (v) =>
                      watch(`${name}`)
                        .flatMap((s) => s[property])
                        .indexOf(v) === index
                  }
                })}
                isInvalid={
                  !!errors?.[bimestre]?.legajos?.[legajoIndex]?.[arrayName]?.[
                    index
                  ]?.[property]
                }
                isValid={
                  !errors?.[bimestre]?.legajos?.[legajoIndex]?.[arrayName]?.[
                    index
                  ]?.[property] &&
                  getValues(`${name}.${index}.${property}`) !== '-1'
                }
              >
                <option key="blankChoice" value="-1">
                  {`Seleccione una ${text}`}
                </option>
                {options.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.nombre}
                  </option>
                ))}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                <ErrorDeducciones
                  tipo={
                    errors?.[bimestre]?.legajos?.[legajoIndex]?.[arrayName]?.[
                      index
                    ]?.[property]?.type
                  }
                />
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="col-5">
              <Form.Label>{`Importe ${index + 1}`}</Form.Label>
              <InputGroup>
                <InputGroup.Prepend
                  className="input-group-addon"
                  style={{ top: '25px' }}
                >
                  <InputGroup.Text id="prependImporteDeduccionesFA">
                    $
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  type="number"
                  name={`${name}.${index}.importe`}
                  defaultValue={field.importe}
                  placeholder="Ingrese el importe"
                  ref={register({
                    required: {
                      value: true,
                      message: 'Es necesario ingresar el importe.'
                    },
                    min: {
                      value: 0,
                      message: 'El importe debe ser mayor a 0.'
                    },
                    pattern: {
                      value: /^\d+[,.]?\d*$/,
                      message: 'Sólo puede ingresar números en este campo.'
                    }
                  })}
                  isInvalid={
                    !!errors?.[bimestre]?.legajos?.[legajoIndex]?.[arrayName]?.[
                      index
                    ]?.importe
                  }
                  isValid={
                    !errors?.[bimestre]?.legajos?.[legajoIndex]?.[arrayName]?.[
                      index
                    ]?.importe && getValues(`${name}.${index}.importe`)
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {
                    errors?.[bimestre]?.legajos?.[legajoIndex]?.[arrayName]?.[
                      index
                    ]?.importe?.message
                  }
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>

            <span className="d-flex align-items-center">
              <button
                className="m-0 py-1 px-2 border-0 rounded bg-white"
                onClick={() => remove(index)}
              >
                <i className="material-icons delete" />
              </button>
            </span>

            <input
              style={{ display: 'none' }}
              name={`${name}.${index}.tipo`}
              defaultValue={arrayName === 'deducciones' ? 'D' : 'E'}
              ref={register({ required: false })}
            />

            <input
              style={{ display: 'none' }}
              name={`${name}.${index}.estado`}
              defaultValue={'A'}
              ref={register({ required: false })}
            />

            <input
              style={{ display: 'none' }}
              name={`${name}.${index}.bimestre`}
              defaultValue={bimestre.slice(-1)}
              ref={register({ required: false })}
            />
          </Form.Row>
        )
      })}
      <Button
        variant="outline-primary"
        className="btn-block my-4"
        onClick={() => {
          const item = { importe: '' }
          item[property] = ''
          append(item)
        }}
      >
        {`Agregar ${text}`}
      </Button>
    </>
  )
}

export function TasaFA({
  name,
  bimestre,
  legajo,
  actividad,
  arrayName,
  property,
  text,
  item,
  methods
}) {
  const { register, errors, getValues, control } = useFormContext()
  const { fields, append, remove } = useFieldArray({
    control,
    name
  })

  return (
    <>
      {fields.map((field, index) => (
        <div key={field.id}>
          <h6 className="text-muted text-uppercase text-center">
            {`${text} ${index + 1}`}
          </h6>
          <hr className="m-0 mb-4" />

          <Row className="align-items-center">
            <Col md={11}>
              <Form.Row>
                <Form.Group className="col-6">
                  <Form.Label>{`Cuit ${index + 1}`}</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ingrese CUIT"
                    name={`${name}.${index}.cuit`}
                    defaultValue={field.cuit}
                    ref={register({
                      required: {
                        value: true,
                        message: 'Es necesario ingresar CUIT'
                      },
                      minLength: {
                        value: 11,
                        message: 'La cuit debe ser de 11 dígitos.'
                      },
                      maxLength: {
                        value: 11,
                        message: 'La cuit debe ser de 11 dígitos.'
                      },
                      pattern: {
                        value: /^\d+$/,
                        message: 'Sólo puede incluir números.'
                      }
                    })}
                    isInvalid={
                      !!errors?.[bimestre]?.[legajo]?.[actividad]?.[
                        arrayName
                      ]?.[index]?.cuit
                    }
                    isValid={
                      !errors?.[bimestre]?.[legajo]?.[actividad]?.[arrayName]?.[
                        index
                      ]?.cuit && getValues(`${name}.${index}.cuit`)
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {
                      errors?.[bimestre]?.[legajo]?.[actividad]?.[arrayName]?.[
                        index
                      ]?.cuit?.message
                    }
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="col-6">
                  <Form.Label>{`Fecha ${index + 1}`}</Form.Label>
                  <Form.Control
                    type="date"
                    placeholder="Ingrese Fecha"
                    name={`${name}.${index}.fecha`}
                    defaultValue={field.fecha}
                    ref={register({
                      required: {
                        value: true,
                        message: 'Es necesario ingresar fecha'
                      }
                    })}
                    min="2019-01-01"
                    max="2019-12-31"
                    isInvalid={
                      !!errors?.[bimestre]?.[legajo]?.[actividad]?.[
                        arrayName
                      ]?.[index]?.fecha
                    }
                    isValid={
                      !errors?.[bimestre]?.[legajo]?.[actividad]?.[arrayName]?.[
                        index
                      ]?.fecha && getValues(`${name}.${index}.fecha`)
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {
                      errors?.[bimestre]?.[legajo]?.[actividad]?.[arrayName]?.[
                        index
                      ]?.fecha?.message
                    }
                  </Form.Control.Feedback>
                </Form.Group>
              </Form.Row>

              <Form.Row>
                <Form.Group className="col-6">
                  <Form.Label>{`Importe ${index + 1}`}</Form.Label>
                  <InputGroup>
                    <InputGroup.Prepend
                      className="input-group-addon"
                      style={{ top: '25px' }}
                    >
                      <InputGroup.Text id="prependImporteTasaFA">
                        $
                      </InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                      type="number"
                      placeholder="Ingrese importe"
                      aria-describedby="prependImporteTasaFA"
                      name={`${name}.${index}.importe`}
                      defaultValue={field.importe}
                      ref={register({
                        required: {
                          value: true,
                          message: 'Es necesario ingresar importe.'
                        },
                        min: {
                          value: 0,
                          message: 'El importe debe ser un número positivo'
                        },
                        pattern: {
                          value: /^\d+[,.]?\d*$/,
                          message: 'Sólo puede ingresar números en este campo'
                        }
                      })}
                      isInvalid={
                        !!errors?.[bimestre]?.[legajo]?.[actividad]?.[
                          arrayName
                        ]?.[index]?.importe
                      }
                      isValid={
                        !errors?.[bimestre]?.[legajo]?.[actividad]?.[
                          arrayName
                        ]?.[index]?.importe &&
                        getValues(`${name}.${index}.importe`)
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {
                        errors?.[bimestre]?.[legajo]?.[actividad]?.[
                          arrayName
                        ]?.[index]?.importe?.message
                      }
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>

                <Form.Group className="col-6">
                  <Form.Label>{`N° Comprobante ${index + 1}`}</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ingrese N° Comprobante"
                    name={`${name}.${index}.comprobante`}
                    defaultValue={field.comprobante}
                    ref={register({
                      required: {
                        value: true,
                        message: 'Es necesario ingresar comprobante.'
                      }
                    })}
                    isInvalid={
                      !!errors?.[bimestre]?.[legajo]?.[actividad]?.[
                        arrayName
                      ]?.[index]?.comprobante
                    }
                    isValid={
                      !errors?.[bimestre]?.[legajo]?.[actividad]?.[arrayName]?.[
                        index
                      ]?.comprobante &&
                      getValues(`${name}.${index}.comprobante`)
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {
                      errors?.[bimestre]?.[legajo]?.[actividad]?.[arrayName]?.[
                        index
                      ]?.comprobante?.message
                    }
                  </Form.Control.Feedback>
                </Form.Group>
              </Form.Row>
            </Col>
            <button
              className="m-0 py-1 px-2 border-0 rounded bg-white"
              onClick={() => remove(index)}
            >
              <i className="material-icons delete"></i>
            </button>
          </Row>

          <input
            style={{ display: 'none' }}
            name={`${name}.${index}.tipo`}
            defaultValue={arrayName === 'retenciones' ? 'R' : 'P'}
            ref={register({ required: true })}
          />

          <input
            style={{ display: 'none' }}
            name={`${name}.${index}.bimestre`}
            defaultValue={bimestre.slice(-1)}
            ref={register({ required: true })}
          />

          <input
            style={{ display: 'none' }}
            name={`${name}.${index}.legajo`}
            defaultValue={legajo.slice(3)}
            ref={register({ required: true })}
          />
        </div>
      ))}
      <Button
        variant="outline-primary"
        className="btn-block my-4"
        onClick={() => append(item)}
      >
        {`Agregar ${text}`}
      </Button>
    </>
  )
}
